import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const login: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { Login } = await import(/* webpackChunkName: "Login" */ '../../../components/pages/public/Login')
      return {
        default: Login,
      }
    })}
    exact
    key={paths.login}
    path={paths.login}
  />,
]
